/*
 * @Author: aiial 2260457739@qq.com
 * @Date: 2022-08-23 08:25:20
 * @LastEditors: aiial 2260457739@qq.com
 * @LastEditTime: 2022-08-26 08:47:22
 * @FilePath: \yifanshangadmin\src\axios.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios";
import Element, { Message, MessageBox } from "element-ui";
import router from "./router";
import store from "./store";
import ty from "./utils/ty";
axios.defaults.baseURL = ty.apiurl;
const request = axios.create({
  timeout: 1000000,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
});
request.interceptors.request.use((config) => {
  var authorization = sessionStorage.getItem("token");
  if (authorization) {
    var items = [
      { pos: authorization.length - 1, str: "AGhdGAUE6Y" },
      { pos: 38, str: "V22" },
      { pos: 26, str: "Sy" },
      { pos: 18, str: "Hi" },
      { pos: 10, str: "Ti" },
      { pos: 1, str: "Ai" },
    ];

    for (let item of items) {
      if (
        authorization.substring(item.pos, item.pos + item.str.length) ===
        item.str
      ) {
        authorization =
          authorization.substring(0, item.pos) +
          authorization.substring(item.pos + item.str.length);
      } else {
        const idx = authorization.indexOf(item.str);
        if (idx !== -1)
          authorization =
            authorization.substring(0, idx) +
            authorization.substring(idx + item.str.length);
      }
    }
  }

  config.headers["Authorization"] = authorization; // 请求头带上token
  return config;
});
request.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code != 0) {
      Message({
        message: res.msg,
        type: "error",
        duration: 5 * 1000,
      });
      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 202 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm(
          "你已被登出，可以取消继续留在该页面，或者重新登录",
          "确定登出",
          {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          store.dispatch("FedLogOut").then(() => {
            location.reload(); //为了重新实例化vue-router对象避免bug
          });
        });
      }
      return Promise.reject("error");
    } else {
      console.log("xxx========》:", res);
      return response.data;
    }
  },
  (error) => {
 if (error.response.data.code === 10000) {
      router.push("/login");
    }
    Message({
      message: error,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);
export default request;
